export class RenameGroupParams {
  uuid: string
  title: string

  constructor({ uuid, title }: { uuid: string, title: string }) {
    this.uuid = uuid
    this.title = title
  }
}
